<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Winged Light</h1>
  </div>

  <div class="sky-card-body">
    <div class="grid grid-2">
      <a class="container" [routerLink]="['/col']">
        <span class="">
          Children of Light <span class="c-accent">({{ col }} / {{ totalCol }})</span>
        </span>
      </a>
      <a class="container" [routerLink]="['/wing-buff']">
        <span class="">
          Wing Buffs <span class="c-accent">({{ wb }} / {{ totalWb }})</span>
        </span>
      </a>
    </div>
  </div>
</div>
